/* global angular */
( function () {
	'use strict';

	function deepLoadingStatusService () {
		var focusedCtrl  = {};
		var loadingKey   = '';
		var loadingCount = { '0' : 1 };
		var lock         = false;

		function setLoadingStatus ( status ) {
			// in case controller has been destroyed/not initialized and loading key is not present
			( focusedCtrl || {} )[ loadingKey || '' ] = status;
		}

		function initialize ( ctrl, doneLoadingKey ) {
			focusedCtrl  = ctrl;
			loadingKey   = doneLoadingKey;
			loadingCount = { '0' : 1 };
			lock         = false;

			// set done loading key to false
			setLoadingStatus( false );
		}

		function getkeys () {
			// return all registered loading count keys
			return Object.keys( loadingCount );
		}

		function getCurrentCount () {
			var currentLoadingCount = 0;

			getkeys().map( function ( loadingCountKey ) {
				// sum up all loading count from all categories
				currentLoadingCount += ( loadingCount[ loadingCountKey ] || 0 );
			} );
			return currentLoadingCount;
		}

		function changeLoadingCount ( newloadingCount, key ) {
			// prevent overflows from different categories during sum of all category counts
			loadingCount[ key ] = Math.max( 0, loadingCount[ key ] + newloadingCount );
			// update loading status on every change on loading count;
			if ( getCurrentCount() < 1 || lock ) {
				lock = true;
				setLoadingStatus( true );
			}
		}

		function incrementLoading ( newloadingCount, key ) {
			var safeKey = key || '0';

			// intially creates an attribute with zero value when attribute does not exist
			if ( getkeys().indexOf( safeKey ) < 0 ) {
				loadingCount[ safeKey ] = 0;
			}
			changeLoadingCount( newloadingCount || 1, safeKey );
		}

		function incrementByArray ( model, loadKey, key ) {
			// wrapped up counting of length to ensure it does not break when component using this call is called without intent of using the service
			var loadCount = ( ( model || {} )[ loadKey ] || [] ).length;

			if ( loadCount ) {
				incrementLoading( loadCount, key );
			}
		}

		function decrementLoading ( newloadingCount, key ) {
			changeLoadingCount( -newloadingCount || -1, key || '0' );
		}

		return {
			'initialize'       : initialize,
			'incrementLoading' : incrementLoading,
			'decrementLoading' : decrementLoading,
			'incrementByArray' : incrementByArray
		};
	}

	angular
		.module( 'app.components' )
		.factory( 'deepLoadingStatusService', deepLoadingStatusService );
} )( );
